import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/leave-management-system/leave-balance/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "leave-balance" entry is kept); the seo block below is a fallback.

export const leaveBalance: ContentPage = {
  slug: "leave-management-system/leave-balance",
  template: "hrmsFeature",
  seo: {
    title: "Leave Balance Tracking - Accurate and Transparent",
    description: "Track employee leave balances in real-time with our Leave Balance tool. Ensure transparency and reduce disputes with accurate leave records.",
    keywords: [
      "leave balance tracking",
      "real-time leave balances",
      "employee leave records",
      "transparent leave management",
      "HR leave tracking",
      "accurate leave balance",
    ],
    ogImage: "/assets/data/seoimages/leave-balance.webp",
  },
  leaf: {
    hero: {
      caption: "Leave Balance",
      title: "Overview of Leave Balance Tracking",
      description: "Gain real-time insights into employee leave balances with our Leave Balance feature. Ensure accurate tracking of available, used, and accrued leave for transparent workforce management.",
      h1: "caption",
    },
    split: {
      title: "Leave Management for Seamless Workforce Efficiency",
      bullets: [
        { title: "Real-Time Tracking", description: "Instantly view updated leave balances for employees and managers." },
        { title: "Accrual Automation", description: "Automate leave accruals based on company policies and regulations." },
        { title: "Policy Customization", description: "Tailor leave policies and accruals to match your business needs." },
        { title: "History Transparency", description: "Access detailed records of leave requests, approvals, and usage." },
      ],
      image: "/assets/images/img/product/hrms/leavems/leave-balance_info.webp",
      imageAlt: "leave-balance_info",
    },
    cardsHeading: {
      title: "Key Features of Leave Management System",
      description: "Optimize leave management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Leave Policy & Allocation",
        href: "/hrms-software/leave-management-system/leave-policy-allocation",
        description: "Create and manage leave policies tailored to your organization’s needs. Allocate leaves based on roles, seniority, and more.",
        image: "/assets/images/img/product/hrms/leavems/leave_policy_and_allocation.webp",
        imageAlt: "leave_policy_and_allocation",
      },
      {
        title: "Leave Accrual Details",
        href: "/hrms-software/leave-management-system/leave-accrual-details",
        description: "Automate the calculation of leave accruals to ensure accurate and fair leave tracking, eliminating manual errors.",
        image: "/assets/images/img/product/hrms/leavems/leave_accrual_details.webp",
        imageAlt: "leave_accrual_details",
      },
      {
        title: "Easy Approval",
        href: "/hrms-software/leave-management-system/leave-approval/",
        description: "Facilitate quick and easy leave request approvals or declines with a user-friendly workflow, keeping your HR processes efficient.",
        image: "/assets/images/img/product/hrms/leavems/easy_approval_decline.webp",
        imageAlt: "easy_approval_decline",
      },
      {
        title: "Leave History",
        href: "/hrms-software/leave-management-system/leave-history",
        description: "Access detailed records of all past leaves, ensuring transparency and easy reference for both employees and HR managers.",
        image: "/assets/images/img/product/hrms/leavems/leave_history.webp",
        imageAlt: "leave_history",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Get Started with Accurate Leave Balance Tracking",
    relatedBlogsKeyword: "leave-management-software-sme,benefits-of-automated-leave-system,real-time-leave-tracking",
    metaKey: "leave-balance",
  },
  sections: [],
};
